// removed by extract-text-webpack-plugin
module.exports = {"title":"_3bN9HGRJbNWWMJB0yk4mIw","ErrorBorder":"_38rbn9twOKCP9xywFBo8Wf","errorMessage":"_3k0nbPCrEK67wlF7uvJDa"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/UserRoute/ChangePassword/style.css
// module id = 2011
// module chunks = 0